// Copyright (c) StrangeBee 2023

import { useLocalMessage } from '@Helpers/';
import { FilterInputForm, ManageFiltersOutput } from '@Hooks/useFilters';
import { Footer } from '@Organisms/ExtendFilterFooter/ExtendFilterFooter';
import { THFilter } from '@Molecules/THFilter/THFilter';
import { useListAllFields } from '@Queries/describeQueries';
import React, { ReactElement, useEffect } from 'react';
import { ObjectTypeV1 } from 'thehive-sdk';

interface WidgetFromFilterProps {
    entity: string;
    onChange?: (value: FilterInputForm[]) => void;
    value?: FilterInputForm[];
    filterManager: ManageFiltersOutput;
}

const WidgetFormFilter = ({ entity, onChange, value, filterManager }: WidgetFromFilterProps): ReactElement => {
    const i = useLocalMessage();
    const { tempFilters, setTempFilters } = filterManager;

    useEffect(() => {
        if (value) {
            setTempFilters(() => value);
        }
    }, []); //eslint-disable-line

    useEffect(() => {
        onChange?.(tempFilters);
    }, [onChange, tempFilters]);

    const { data: describe } = useListAllFields();

    if (!entity) {
        return <div className="no-item-label">{i('dashboard.filter.no-entity')}</div>;
    }

    return (
        <div className="widget-form-filters">
            <THFilter
                describeField={describe?.[entity as ObjectTypeV1]}
                filterConfig={filterManager}
                aggregationWarning
            >
                <Footer filterConfig={filterManager} canApplyFilter={false} />
            </THFilter>
        </div>
    );
};

export default WidgetFormFilter;
